import { render, staticRenderFns } from "./df-link-button.vue?vue&type=template&id=00d22042"
import script from "./df-link-button.ts?vue&type=script&lang=js&external"
export * from "./df-link-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports